(function ($) {
    $('.e-services-slider').each(function () {
        const $slider = $(this);
        const slideCount = $slider.children().length;

        if (slideCount < 3) {
            return;
        }

        const $prev = $slider.closest('.e-services').find('.e-services__prev');
        const $next = $slider.closest('.e-services').find('.e-services__next');
        const $dots = $slider.closest('.e-services').find('.e-services__dots');

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true,
            arrows: false,
            dots: true,
            appendDots: $dots,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        $prev.on('click', function () {
            $slider.slick('slickPrev');
        });

        $next.on('click', function () {
            $slider.slick('slickNext');
        });
    });
})(jQuery);
